// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type UserCircle20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const UserCircle20: FC<UserCircle20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M4.938 14.063a8.33 8.33 0 0 1 2.406-1.178A9.172 9.172 0 0 1 10 12.5c.917 0 1.802.129 2.656.385a8.33 8.33 0 0 1 2.406 1.178 5.747 5.747 0 0 0 1.084-1.896A6.685 6.685 0 0 0 16.5 10c0-1.801-.633-3.335-1.9-4.6-1.268-1.267-2.802-1.9-4.605-1.9-1.802 0-3.335.633-4.6 1.9C4.133 6.664 3.5 8.198 3.5 10c0 .75.118 1.472.354 2.167a5.747 5.747 0 0 0 1.083 1.896ZM10 11.5a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 7 8.5c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 10 5.5c.833 0 1.542.292 2.125.875S13 7.667 13 8.5s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 10 11.5Zm.006 6.5a7.81 7.81 0 0 1-3.11-.625 8.064 8.064 0 0 1-2.552-1.719 8.065 8.065 0 0 1-1.719-2.551A7.819 7.819 0 0 1 2 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 0 1 4.27-4.26A7.819 7.819 0 0 1 10.01 2a7.75 7.75 0 0 1 3.105.625 8.082 8.082 0 0 1 4.26 4.265A7.77 7.77 0 0 1 18 9.994a7.81 7.81 0 0 1-.625 3.11 8.063 8.063 0 0 1-1.719 2.552 8.081 8.081 0 0 1-2.546 1.719 7.77 7.77 0 0 1-3.104.625ZM10 16.5c.722 0 1.417-.115 2.083-.344a6.64 6.64 0 0 0 1.875-1.01 7.495 7.495 0 0 0-1.896-.854A7.327 7.327 0 0 0 10 14c-.708 0-1.4.094-2.073.281a6.542 6.542 0 0 0-1.885.865 6.641 6.641 0 0 0 1.875 1.01c.666.23 1.36.344 2.083.344Zm0-6.5c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0 0 10 7c-.417 0-.77.146-1.063.438A1.447 1.447 0 0 0 8.5 8.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437Z" />
        </svg>
    );
};

export default UserCircle20;
